import {batch, useDispatch, useSelector} from "react-redux";
import RemoteLogo from "../atoms/RemoteLogo";
import Logo from "../atoms/Logo";
import React, {useCallback, useEffect, useMemo} from "react";
import {menuAction, optionAction, toggleAction} from "../../../redux/store";
import callPeerRemoteModule from "../../../../core/utils/callPeerRemoteModule";
import {useParams} from "react-router-dom";

const Header = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const reg = useMemo(() => /[\{\}\[\]\/?.,;:|\)*~`!^\+<>@\#$%&\\\=\(\'\"]/gi, []);
  const navData = useSelector(state => state.menuOpen.navData);
  const connectMode = useSelector(state => state.theme.connectMode);
  const currentNavigation = useSelector(state => state.optionWindow.currentNavigation);

  const headerClickHandler = useCallback(async (item) => {
    const peer = await callPeerRemoteModule(connectMode);
    if (!item || item.id === currentNavigation) return;

    dispatch(optionAction.setCurrentHeader(item.id));

    peer?.conn.sendData("dispatch", {
      action: "optionAction",
      func: "setCurrentHeader",
      payload: item.id
    });


    const itemId = item.id.replaceAll(reg, "");

    batch(() => {
      dispatch(optionAction.setCurrentNavigation(itemId));
      dispatch(optionAction.setOptions({ selection: "isGnb", value: item.gnb }));
    });

    if (peer) {
      peer.conn.sendData("dispatch", {
        action: "optionAction",
        func: "setCurrentNavigation",
        payload: itemId
      });

      if (item.gnb) {
        dispatch(toggleAction.resetMovingPartsState());
        peer.conn.sendData("anim:allInstantClose");
      }
    }

  }, [connectMode, currentNavigation, dispatch, reg]);


  useEffect(() => {
    if (connectMode !== "web") return;

    const path = params["*"]?.split("/");
    if (!path) return;

    const pathIndex = path.length - 1;
    if (path[pathIndex] !== "") {
      const clickedData = navData?.navForHeader?.find(
        item => item.id.replace(/[/?]/g, "") === path[pathIndex]
      );
      if (clickedData) {
        headerClickHandler(clickedData);
      }
    }
  }, [params, navData?.navForHeader, connectMode, headerClickHandler]);

  return (
    <header>
      <button
        type="button"
        className="open-menu"
        onClick={() => dispatch(menuAction.menuToggle())}
      >
        Open menu
      </button>
      {connectMode === "remote" ? <RemoteLogo /> : <Logo/>}
    </header>
  );
};


export default Header;
